import { AxiosError, TPrePurchase, TPurchaseCoupon } from "@/api";
import { atom } from "jotai";

export const prePurchaseAtom = atom<TPrePurchase | null>(null);
export const prePurchaseErrorAtom = atom<AxiosError<any> | null>(null);
